import React, { useState } from 'react';
import { IG, FB, TT, Logo } from './shared';
import { subscribeEmail } from '../api';

export default function Footer({ go }) {
  const [val, setVal] = useState('');
  const [label, setLabel] = useState('Sign Up');
  const submit = async () => {
    if (!val.includes('@')) return;
    setLabel('Thanks!'); const email = val; setVal('');
    try { await subscribeEmail(email, 'footer'); } catch (e) { /* still show success */ }
    setTimeout(() => setLabel('Sign Up'), 2500);
  };
  return (
    <footer>
      <div className="footer-inner">
        <div className="footer-top">
          <div>
            <Logo size="foot" />
            <div className="footer-brand-social">
              <a href="https://instagram.com/southbeachblooms" target="_blank" rel="noreferrer" aria-label="Instagram"><IG /></a>
              <a href="https://facebook.com/southbeachblooms" target="_blank" rel="noreferrer" aria-label="Facebook"><FB /></a>
              <a href="https://tiktok.com/@southbeachblooms" target="_blank" rel="noreferrer" aria-label="TikTok"><TT /></a>
            </div>
            <p className="footer-tagline">Welcome to South Beach Blooms, where style, abundance and quality are synonymous with our Torquay Flower Farm. We grow beautiful seasonal blooms on Victoria's Surf Coast, cut fresh from the paddock to your hands. We specialise in dahlia tubers — beautiful, ridiculously good varieties hand-selected and shipped Australia-wide (excluding TAS and WA), so if you're searching for dahlia tubers for sale, you've just found your people.</p>
            <p className="footer-seo">Buy dahlia tubers Australia · Dahlia tubers for sale · Dahlia tubers Torquay · Dahlia tubers bulk · Torquay flower farm · Surf Coast flowers</p>
          </div>
          <div className="footer-col"><h4>Shop</h4><ul>
            <li><a onClick={() => go('tubers')}>All Dahlia Tubers</a></li>
            <li><a onClick={() => go('tubers')}>Bulk Orders</a></li>
            <li><a onClick={() => go('home', { scrollToFlowers: true })}>Flowers</a></li>
          </ul></div>
          <div className="footer-col"><h4>About</h4><ul>
            <li><a onClick={() => go('discover')}>Discover South Beach Blooms</a></li>
            <li><a onClick={() => go('home', { scrollToFlowers: true })}>Flowers</a></li>
            <li><a onClick={() => go('blog')}>The Journal</a></li>
            <li><a onClick={() => go('contact')}>Contact</a></li>
            <li><a onClick={() => go('terms')}>Terms of Service</a></li>
            <li><a onClick={() => go('privacy')}>Privacy Policy</a></li>
          </ul></div>
          <div className="footer-col"><h4>Community</h4><ul>
            <li><a onClick={() => go('tubers', { scrollToJoin: true })}>Join the List</a></li>
            <li><a href="https://instagram.com/southbeachblooms" target="_blank" rel="noreferrer">Instagram</a></li>
          </ul></div>
          <div className="footer-col"><h4>Visit &amp; Updates</h4>
            <div className="footer-hours">
              <div className="footer-hours-row"><span>Farm Gate</span><span>Open in season</span></div>
              <div className="footer-hours-row"><span>Visits</span><span>By arrangement</span></div>
              <div className="footer-hours-row"><span>Tuber Shipping</span><span>AUS-wide</span></div>
            </div>
            <input className="footer-newsletter-input" placeholder="your@email.com" style={{ marginTop: 14 }} value={val} onChange={(e) => setVal(e.target.value)} />
            <button className="footer-newsletter-btn" onClick={submit}>{label}</button>
          </div>
        </div>
      </div>

      <p className="footer-ack">Torquay Flower Farm acknowledges the Wadawurrung people, the Traditional Custodians of the land on which we grow, and pays respect to their Elders past, present and emerging.</p>

      <div className="footer-bottom">
        <span className="footer-copy">© 2026 Torquay Flower Farm. Torquay VIC 3228. All rights reserved.</span>
      </div>

      <div className="footer-flowers">
        <img src="/brand/footer-flowers.png" alt="" />
      </div>
    </footer>
  );
}
